<div class="ofensores">
  <h3>{{ 'COMPONENTS.MAPA.DIALOGS.OFFENDERS' | transloco }}</h3>
  <div class="progress-container">
    <div class="progress-bar-wrapper">
      <div class="progress-segments">
        @for (ofensor of ofensoresFormatados; track ofensor.classe) {
          <div 
            class="segment {{ofensor.classe}}" 
            [style.width.%]="ofensor.porcentagem"
          >
            {{ofensor.porcentagem}}%
          </div>
        }
      </div>
    </div>
    <div class="legenda">
      <div class="legenda-coluna">
        @for (ofensor of ofensoresFormatados.slice(0, Math.ceil(ofensoresFormatados.length / 2)); track ofensor.classe) {
          <div class="legenda-item">
            <span class="legenda-cor {{ofensor.classe}}"></span>
            <span class="legenda-texto">{{ofensor.nome}}</span>
          </div>
        }
      </div>
      <div class="legenda-coluna">
        @for (ofensor of ofensoresFormatados.slice(Math.ceil(ofensoresFormatados.length / 2)); track ofensor.classe) {
          <div class="legenda-item">
            <span class="legenda-cor {{ofensor.classe}}"></span>
            <span class="legenda-texto">{{ofensor.nome}}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
